@use '@/scss/underscore' as _;

.planQuotaList {
  margin-block: 0;
  padding-inline: 0;

  > li {
    &:not(:first-child) {
      margin-top: _.unit(3);
    }
  }
}
